import React, { useRef, useState } from "react";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { add, update } from "../../service/industryService";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { rolesAdd, rolesUpdate } from "../../service/rolesService";

export default function RolesAdd(modalProps: any) {

  const record = modalProps.record;

  const [name, setName] = useState(record?.name || "");
  const [access, setAccess] = useState(record?.access_level || "");
  const [nameError, setNameError] = useState(false);

  async function addIndustry() {
    const updateObject = {
      name: name,
      client: modalProps.client,
      access_level: access
    }
    setNameError(!name || name === '');
    if (!name || name === '') {
      modalProps.toast.current.show({ severity: 'warn', summary: 'Please enter all required fields', life: 3000 });
      return;
    }
    modalProps.setGlobalLoader(true);
    if (modalProps.id) {
      rolesUpdate(updateObject, record.id).then((r: any) => {
        modalProps.setVisible(false);
        modalProps.setGlobalLoader(false);
        modalProps.setReload(!modalProps.reload);
        modalProps.toast.current.show({ severity: 'success', summary: 'Role Updated Successfully', life: 3000 });
      })
    } else {
      rolesAdd(updateObject).then((r: any) => {
        modalProps.setVisible(false);
        modalProps.setGlobalLoader(false);
        modalProps.setReload(!modalProps.reload);
        modalProps.toast.current.show({ severity: 'success', summary: 'Role Added Successfully', life: 3000 });
      })
    }
  }

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Role Name<div style={{ color: 'red' }}>*</div></FormLabel>
            <FormControl
              error={nameError}
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input value={name} size="sm" placeholder="Role Name" onChange={e => setName(e.target.value)} />
            </FormControl>
          </Stack>
          <Stack spacing={1}>
            <DropdownApi apiPath='access-level' optionLabel="name" optionValue='id' label='Access Level' selectedData={access} setSelectedData={setAccess} />
          </Stack>
        </Stack>
      </Stack>
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => addIndustry()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}